import script from "./ActivityRegistrationList.vue?vue&type=script&setup=true&lang=js"
export * from "./ActivityRegistrationList.vue?vue&type=script&setup=true&lang=js"

import "./ActivityRegistrationList.vue?vue&type=style&index=0&id=c944ed3a&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c944ed3a"]])

export default __exports__